// type CouponType = number;

export enum CouponType {
  UNKNOWN,
  STATIC,
  PERCENT,
}

// export const STATIC: CouponType = 1; // example: 10 PLN off
// export const PERCENT: CouponType = 2; // example 20% off



export class Coupon {

  public id: string = '';
  public name: string = '';
  public discount_type: CouponType = CouponType.UNKNOWN;
  public valid_to: number = 0;
  public valid_from: number = 0;
  public value: number = 0;
  public region: string = '';
  public restaurant_id: string = '';
  public business_group_id: string = ''; // not implemented in API yet
  public active: boolean = false;

  constructor() {}

  toJSON(): Object {
    return {
      "id": this.id,
      "name": this.name,
      "discount_type": this.discount_type,
      "valid_from": this.valid_from,
      "valid_to": this.valid_to,
      "value": this.value,
      "active": this.active,

    }
  }

}
